export default __webpack_public_path__ + "46a1b681490b3b4003cf40b8260a1efb.png";